import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

function getDefaultLang() {
  const saved = localStorage.getItem('lang');
  if (saved && (saved === 'en' || saved === 'es')) return saved;
  const nav = navigator.language || 'en';
  return nav.startsWith('es') ? 'es' : 'en';
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(getDefaultLang);

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem('lang', l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used inside LanguageProvider');
  return ctx;
}

export function useT(translations) {
  const { lang } = useLang();
  return translations[lang] || translations.en;
}
